// extracted by mini-css-extract-plugin
export default {"imageWrapper":"qH-z","twoColumnImage":"rH-z"};